angular.module('tikonApp').directive('eoSchedulerLazy', ['DateUtil', '$mdDialog', '$timeout', 'TimingInfo', '$localStorage', 'ENV',
    function (dateUtil, $mdDialog, $timeout, timingInfo, $localStorage, ENV) {
        return {
            restrict: 'A',
            scope: {serviceItemId: '=?', timingInfo: '=?', refreshTimingInfo: '&?', accessLevel: '<?'},
            transclude: true,
            templateUrl: 'app/components/eyeson/scheduler/eyeson.scheduler.template.html',

            link: function ($scope, $element, $attrs, $controller) {

                var scheduleIsLoaded = false;
                var eventsInited = false;
                var onCratingNewEvent = false;
                var serviceId;
                var canSeeReserve = true;
                +
                    //  $scope.schedulerApi.refreshScheduler = refreshScheduler;
                    //adjust size of a scheduler
                    $timeout(function () {
                        $scope.$watch('serviceItemId', function (serviceItemId) {
                            serviceId = serviceItemId;

                            if (serviceItemId) {
                                // alert(serviceItemId);
                                $scope.$watch('timingInfo', function (timingInfo) {
                                    if (timingInfo) {
                                        initSchedule();
                                        configScheduler(timingInfo);
                                        setSchedulerDataSource();
                                        $scope.$watch(function () {
                                            return $element[0].offsetWidth + "." + $element[0].offsetHeight;
                                        }, function () {
                                            scheduler.setCurrentView();
                                        });

                                    }
                                });

                            }
                        });
                    }, 0);


                function refreshScheduler() {
                    //   alert('refresh called');
                    regenerateEvents($scope.timingInfo);
                }

                function configScheduler(timingInfo) {


                    scheduleIsLoaded = false;
                    var first_hour = 0;
                    var last_hour = 24;
                    var limit_start = new Date();
                    var limit_end = new Date('3000-01-01');
                    if (timingInfo && timingInfo.startTime)
                        first_hour = (new Date(timingInfo.startTime)).getHours();
                    if (timingInfo && timingInfo.endTime)
                        last_hour = (new Date(timingInfo.endTime)).getHours();
                    if (timingInfo && timingInfo.fromDate)
                        limit_start = new Date(timingInfo.fromDate);
                    if (timingInfo && timingInfo.toDate)
                        limit_end = new Date(timingInfo.toDate);
                    scheduler.config.first_hour = first_hour;
                    scheduler.config.last_hour = last_hour;
                    scheduler.config.limit_start = limit_start;
                    scheduler.config.limit_end = limit_end;
                    scheduler.config.limit_view = true;


                    clearSchedule();
                }

                function regenerateEvents(timingInfo) {


                    scheduleIsLoaded = false;
                    var first_hour = 0;
                    var last_hour = 23;
                    var limit_start = new Date();
                    var limit_end = new Date('3000-01-01');
                    if (timingInfo && timingInfo.startTime)
                        first_hour = (new Date(timingInfo.startTime)).getHours();
                    if (timingInfo && timingInfo.endTime)
                        last_hour = (new Date(timingInfo.endTime)).getHours();
                    if (timingInfo && timingInfo.fromDate)
                        limit_start = new Date(timingInfo.fromDate);
                    if (timingInfo && timingInfo.toDate)
                        limit_end = new Date(timingInfo.toDate);
                    scheduler.config.first_hour = first_hour;
                    scheduler.config.last_hour = last_hour;
                    scheduler.config.limit_start = limit_start;
                    scheduler.config.limit_end = limit_end;
                    scheduler.config.limit_view = true;


                    scheduler.updateView(limit_start);


                    clearSchedule();
                    if (timingInfo != undefined && timingInfo.availableTimes != undefined) {
                        //adding offtimes
                        angular.forEach(timingInfo.offDates, function (date) {

                            var eid = scheduler.addMarkedTimespan({
                                    days: new Date(date),
                                    // end_date:    new Date(date),
                                    //  type: "dhx_time_block"
                                    type: "dhx_offTime_block",
                                    css: "sch-offDate",
                                    zones: "fullday"
                                }
                            );
                        });
                        angular.forEach(timingInfo.offDaysOfWeek, function (day) {
                            //
                            var offdays = [];
                            offdays.push(convertWeekNameToOrder(day));
                            var eid = scheduler.addMarkedTimespan({
                                    days: offdays,
                                    // end_date:    new Date(date),
                                    //  type: "dhx_time_block"
                                    type: "dhx_offTime_block",
                                    css: "sch-offDate",
                                    zones: "fullday"
                                }
                            );
                        });
                        angular.forEach(timingInfo.offTimes, function (time) {

                            var zones = [];
                            var startTime = new Date(time.startTime);
                            var endTime = new Date(time.endTime);
                            var startMin = startTime.getMinutes();
                            var endMin = endTime.getMinutes();

                            zones.push(startTime.getHours() * 60 + startMin);
                            zones.push(endTime.getHours() * 60 + endMin);
                            //console.log(zones);
                            var eid = scheduler.addMarkedTimespan({
                                    zones: zones,
                                    days: "fullweek",
                                    css: "sch-offDate",
                                    // end_date:    new Date(date),
                                    //  type: "dhx_time_block"
                                    type: "dhx_offTime_block"

                                }
                            );
                        });

                        //adding events
                        var events = [];
                        scheduleIsLoaded = false;
                        var i = 0;
                        angular.forEach(timingInfo.availableTimes, function (time) {

                            i++;
                            //
                            //var startTime=dateUtil.fromString(time.startTime);
                            //console.log('startTime:');
                            //console.log(startTime);
                            var eid = scheduler.addEvent(
                                new Date(time.startTime),
                                new Date(time.endTime),
                                '',
                                time.id,   //userdata

                                //time.id,
                                time
                            );
                            time.id = eid;
                            eid.readonly = true;
                            if (i == timingInfo.availableTimes.length) {
                                scheduleIsLoaded = true;
                                eventsInited = true;
                                //  alert(i+scheduleIsLoaded);
                            }
                            //    events.push(time);
                            //  console.log('event added : ' + eid);

                        });

                        scheduler.updateView(limit_start);
                        scheduleIsLoaded = true;
                    }
                }


                function onDoubleClick(id, e) {
                    if (!onCratingNewEvent)
                        scheduler.showLightbox(id);
                }


                function convertWeekNameToOrder(day) {
                    var index = DAYS_VALUES.indexOf(day);
                    if (index == 0) return 6;
                    return index - 1;

                }

                function clearSchedule() {
                    scheduler.clearAll();
                    scheduler.deleteMarkedTimespan();
                }


                function setSchedulerDataSource() {
                    scheduler.setLoadMode("week");
                    scheduler.load(ENV.API_BASE_URL + "api/client/getSchedulerEventByServiceItem/" + $scope.serviceItemId, "json", function (data) {

                        //alert(data);
                    });
                }

                function AddNewTimeSession(ev) {
                    var timeSpan = {
                        startTime: new Date(ev.start_date),
                        endTime: new Date(ev.end_date),
                        serviceItemId: serviceId
                    };
                    timingInfo.addNewTimeSession().save(timeSpan);
                    console.log('time session create');
                    console.log(ev);
                    onCratingNewEvent = false;

                }

                function initSchedule() {


                    //styling for dhtmlx scheduler
                    $element.addClass("dhx_cal_container");

                    scheduler.config.start_on_monday = false;
                    //scheduler.config.show_loading = true;
                    //init scheduler
                    //
                    scheduler.templates.event_class = function (start, end, ev) {
                        if (ev.hidden) {
                            console.log(ev.id + ' is hidden');
                            return "scheduler_hidden_event";
                        }


                        if (ev.reserveRequestCount > 0) {
                            return "scheduler_has_orders_to_confirm"
                        }
                        if (ev.waitToPayRequestCount > 0) {
                            return "scheduler_has_orders_to_pay"
                        }
                        if (!ev.enable) {
                            return "scheduler_not_enable";
                        }
                        if (!ev.capacity > 0) {
                            return "scheduler_no_capacity";

                        }
                        if (ev.confirmedRequestCount > 0) {
                            return "scheduler_has_confirmed_orders"
                        }


                        return "scheduler_available";
                    }
                    var mode = "week";
                    var start_date = new JDate();
                    if ($localStorage.timeline_mode != undefined)
                        mode = $localStorage.timeline_mode;

                    if ($localStorage.timeline_startDate != undefined) {
                        start_date.date[0]
                        var d = $localStorage.timeline_startDate;
                        if (d.date != undefined && d.date[0] != undefined)
                            start_date = new JDate(d.date[0], d.date[1], d.date[2]);
                    }
                    if (screen.width <= 480) {
                        scheduler.init($element[0], start_date, "day");
                    } else {
                        scheduler.init($element[0], start_date, mode);
                    }

                    scheduler.config.icons_select = [
                        //"icon_details",
                        //
                        //"icon_delete"
                    ];

                    scheduler.attachEvent("onClick", onDoubleClick);
                    scheduler.attachEvent("onEventAdded", function (e, event) {
                        //   AddNewTimeSession(event);
                    });
                    scheduler.attachEvent("onEventCreated", function (e) {
                        onCratingNewEvent = true;
                    });
                    scheduler.attachEvent("onEventCancel", function (e) {
                        onCratingNewEvent = false;
                    });
                    scheduler.attachEvent("onBeforeViewChange", function (old_mode, old_date, mode, date) {
                        console.log(old_mode + ":" + old_date);
                        $localStorage.timeline_mode = mode;

                        $localStorage.timeline_startDate = date;
                        //any custom logic here
                        return true;
                    });
                    scheduler.templates.event_text = eventTextTemplate;
                    scheduler.templates.tooltip_text = eventTooltipTemplate;
                    dhtmlXTooltip.config.className = 'dhtmlXTooltip tooltip';
                    dhtmlXTooltip.config.timeout_to_display = 500000000;
                    scheduler.config.separate_short_events = true;
                    //scheduler.config.hour_size_px = 70;
                    dhtmlXTooltip.config.delta_x = 15;
                    dhtmlXTooltip.config.delta_y = -20;

                    function eventTextTemplate(start, end, event) {
                        return '<span>' + event.text + '-' + ' </span><span style="color:#aed581"> <span  class="glyphicon glyphicon-user">  </span>' + event.capacity + '</span>';


                    }

                    function eventTooltipTemplate(start, end, event) {

                        if (!event.price) event.price = 0;
                        if (!event.discount) event.discount = 0;

                        var tooltipHtml = '<div class="scheduler_tooltip" >' +
                            '<p>' + event.text + '</p>' +
                            '<li> ظرفیت موجود : ' + event.capacity + '</li>' +
                            '<li> قیمت : ' + event.price + '</li>' +
                            '<li> تخفیف : ' + event.discount + '</li>' +
                            '</div>';
                        return tooltipHtml;
                    };

                    var lightBoxForm = document.getElementById("light_box_form");
                    isShowing = false;
                    scheduler.showLightbox = function (id) {

                        //console.log('dialog show');
                        var ev = scheduler.getEvent(id);
                        console.log(ev);
                        ev.updateEvent = function () {
                            scheduler.updateEvent(id);
                        };
                        if (!isShowing) {

                            showCustomLightBox(ev, $scope.refreshTimingInfo);
                            isShowing = true;
                        }
                        //     scheduler.startLightbox(id, lightBoxForm);
                        //...'here you need to set values in the form'...
                        //document.getElementById("some_input").value = ev.text;
                    }

                    //clearSchedule();
                    //scheduler.updateView();
                    //clearSchedule();
                }

                function showCustomLightBox(dialogData, refreshTimingInfoMethod) {

                    $mdDialog.show({
                        locals: {dialogData: dialogData, refreshTimingInfoMethod: refreshTimingInfoMethod},
                        controller: SchedulerTimeSessionController,
                        controllerAs: '$ctrl',
                        templateUrl: 'app/components/eyeson/scheduler/eyeson.scheduler-time-session-dialog.template.html',
                        parent: angular.element(document.body),
                        targetEvent: dialogData,
                        clickOutsideToClose: true,
                        fullscreen: false// Only for -xs, -sm breakpoints.
                    })
                        .then(function (ev) {

                            isShowing = false;


                        }, function () {

                            isShowing = false;
                        });
                };
                var SchedulerTimeSessionController = function ($scope, $mdDialog, dialogData, refreshTimingInfoMethod, TimingInfo, $state, DateUtils) {
                    var $ctrl = this;
                    $ctrl.dialogData = dialogData;
                    $ctrl.refreshTimingInfoMethod = refreshTimingInfoMethod;
                    //$ctrl.dialogData = {
                    //    id: dialogData.id,
                    //    price: dialogData.price,
                    //    capacity: dialogData.capacity,
                    //    enable: dialogData.enable,
                    //    discount: dialogData.discount,
                    //    isNew:dialogData.isNew
                    //};

                    var startDate = new JDate(dialogData.start_date);
                    var endDate = new JDate(dialogData.end_date);
                    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                    if (startDate && endDate) {
                        $ctrl.title = startDate.format('dddd DD MMMM ') + '-' + 'ساعت' +
                            startDate.format('HH:SS') + ' - ' + endDate.format('HH:SS');


                    }


                    $ctrl.hideDialog = function () {
                        $mdDialog.hide();
                    };

                    $ctrl.cancelDialog = function () {
                        $mdDialog.cancel();
                    };
                    $ctrl.copyTSimilarTimes = function () {
                        if (confirm("در صورت تایید ، خصوصیات این زمان در دیگر زمانهای این سرویس که ساعت مشابهی دارند کپی می شود. آیا اطمینان دارید؟")) {
                            TimingInfo.updateToSimilarTimeSessions($ctrl.dialogData.id).get(function () {
                                alert("تغییرات با موفقیت انجام شد. برای مشاهده دکمه بازیابی تقویم کاری را بزنید")
                                //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                            });
                        }
                    }

                    $ctrl.gotoNewReserve = function (serviceItemId) {
                        $mdDialog.hide();
                        console.log(dialogData);
                        if (dialogData.floatTime) {

                            $state.go('supplierPanel.orderBagWithDateRangeParameter', {
                                serviceItemId: dialogData.serviceItemId,
                                start_date: DateUtils.jdateToDate(dialogData.start_date).toISOString(),
                                end_date: DateUtils.jdateToDate(dialogData.end_date).toISOString()
                            });


                        } else {
                            $state.go('supplierPanel.orderBagWithParameter', {
                                serviceItemId: dialogData.serviceItemId,
                                timeSessionId: dialogData.id
                            });


                        }
                        /*  var url = $state.href('supplierPanel.orderBagWithParameter', {
                              serviceItemId: serviceItemId,
                              timeSessionId: dialogData.id
                          });

                          window.open(url,'_blank');*/
                        //   window.open(url,'_self');

                    }

                    $ctrl.updateCapacity = function (value) {

                        if ($ctrl.dialogData.floatTime) {
                            $ctrl.dialogData.capacity = value;
                            $ctrl.upsertFloatTimeSession($ctrl.dialogData);
                        } else
                            TimingInfo.changeTimeSessionCapacity($ctrl.dialogData.id, value).get(function () {
                                dialogData.capacity = value;
                                //    $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                                $ctrl.refreshTimingInfoMethod();
                            });
                        return true;
                    }
                    $ctrl.updateDiscount = function (value) {
                        if (data.floatTime) {
                            $ctrl.dialogData.discount = value;
                            $ctrl.upsertFloatTimeSession(data);
                        } else
                            TimingInfo.changeTimeSessionDiscount($ctrl.dialogData.id, value).get(function () {
                                dialogData.discount = value;
                                //   $ctrl.timeSessionDtail = TimingInfo.getTimeSessionDtailByTimeSessionId(dialogData.id).get();
                                dialogData.updateEvent();
                            });
                        return true;
                    }
                    $ctrl.gotoOrderBag = function (id) {
                        $mdDialog.hide();
                        $state.go('supplierPanel.editOrderBag', {id: id});

                    }
                    $ctrl.changeEnable = function (data) {

                        //if(data.floatTime)
                        //{
                        data.enable = !data.enable;
                        $ctrl.upsertFloatTimeSession(data);
                        //}
                        //else
                        //TimingInfo.changeTimeSessionEnable(data.id).get(function () {
                        //    $ctrl.dialogData.enable = !$ctrl.dialogData.enable;
                        //    dialogData.enable = $ctrl.dialogData.enable;
                        //    dialogData.updateEvent();
                        //});
                    }
                    $ctrl.upsertFloatTimeSession = function (ev) {
                        ev.start_date = new Date(ev.start_date);
                        ev.end_date = new Date(ev.end_date);
                        ev.orderBagStatusList = [0, 1];
                        //      var timeSpan={startTime:new Date(ev.start_date),endTime: new Date( ev.end_date),serviceItemId:serviceId};
                        timingInfo.upsertFloatTimeSession().save(ev, function (result) {

                            $ctrl.refreshTimingInfoMethod();
                            $ctrl.cancelDialog();
                        });
                        console.log('time session create');
                        console.log(ev);
                        onCratingNewEvent = false;

                    }
                    $ctrl.saveDialog = function (answer) {
                        dialogData.price = $ctrl.dialogData.price;
                        dialogData.discount = $ctrl.dialogData.discount;
                        dialogData.capacity = $ctrl.dialogData.capacity;
                        dialogData.enable = $ctrl.dialogData.enable;
                        dialogData.updateEvent();
                        $mdDialog.hide(answer);
                    };
                }
                SchedulerTimeSessionController.$inject = ['$scope', '$mdDialog', 'dialogData', 'refreshTimingInfoMethod', 'TimingInfo', '$state', 'DateUtils', 'ENV'];


            }//end of link method
        }
    }]);
